import { theme } from 'config';
import { Timeslice } from 'scenes/Report/Report.helper';

const { violet, deepPurple, coral, softViolet, seafoamGreen, yellow } = theme;

type ViewDropDown = 'sevenDays' | 'fourteenDays' | 'thirtyDays';

type AttributionRate = {
  attributedRate: number;
  appClickAttributedRate: number;
  appImpressionAttributedRate: number;
  emailOpenAttributedRate: number;
  pushNotificationAttributedRate: number;
  socialAttributionRate: number;
};

type Event = {
  merchantName: string;
  eventDate: Date;
  sevenDays: AttributionRate;
  fourteenDays: AttributionRate;
  thirtyDays: AttributionRate;
};

type Attribution = {
  result: Event[];
  timeslice: Timeslice;
  sevenDayAvg: number;
  fourteenDayAvg: number;
  thirtyDayAvg: number;
};

type ChartLegend = {
  path?: string[] | string;
  title: string;
  color: string;
  hidden: boolean;
};

type GraphData = {
  eventDate: number;
  value: any;
};

const getChartLegend = (isHidden: boolean) => {
  return [
    { path: 'attributedRate', title: 'Attribution Rate', color: deepPurple },
    {
      path: 'appClickAttributedRate',
      title: 'App Clicks',
      color: violet,
      hidden: isHidden,
    },
    {
      path: 'appImpressionAttributedRate',
      title: 'App Impressions',
      color: seafoamGreen,
      hidden: isHidden,
    },
    {
      path: 'emailOpenAttributedRate',
      title: 'Email Opens',
      color: softViolet,
      hidden: isHidden,
    },
    {
      path: 'pushNotificationAttributedRate',
      title: 'Push Notifications',
      color: coral,
      hidden: isHidden,
    },
    {
      path: 'socialAttributionRate',
      title: 'Social Attribution',
      color: yellow,
      hidden: isHidden,
    },
  ];
};

const viewOptions = [
  {
    key: 'sevenDays',
    text: '7 Days',
    value: 'sevenDays',
  },
  {
    key: 'fourteenDays',
    text: '14 Days',
    value: 'fourteenDays',
  },
  {
    key: 'thirtyDays',
    text: '30 Days',
    value: 'thirtyDays',
  },
];

export {
  Attribution,
  ChartLegend,
  ViewDropDown,
  Event,
  GraphData,
  getChartLegend,
  viewOptions,
};
